import ExplorePage from "@app/pages/explore/explore-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/_authed/explore")({
  head: () => pageHead("Explore"),
  component: ExploreRoute,
});

function ExploreRoute() {
  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading Explore</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading analytics...</div>}
      >
        <ExplorePage />
      </Suspense>
    </ErrorBoundary>
  );
}
